/** localStorage flags for complete / dismiss / bookmark / pin (000001). */

import type { LocalActionFlags } from './types';

const KEY = 'command-center-000001-local';

const empty = (): LocalActionFlags => ({
  completed: [],
  dismissed: [],
  bookmarked: [],
  pinned: [],
});

export function loadLocalFlags(): LocalActionFlags {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return empty();
    const parsed = JSON.parse(raw) as Partial<LocalActionFlags>;
    return {
      completed: Array.isArray(parsed.completed)
        ? parsed.completed.filter((x): x is string => typeof x === 'string')
        : [],
      dismissed: Array.isArray(parsed.dismissed)
        ? parsed.dismissed.filter((x): x is string => typeof x === 'string')
        : [],
      bookmarked: Array.isArray(parsed.bookmarked)
        ? parsed.bookmarked.filter((x): x is string => typeof x === 'string')
        : [],
      pinned: Array.isArray(parsed.pinned)
        ? parsed.pinned.filter((x): x is string => typeof x === 'string')
        : [],
    };
  } catch {
    return empty();
  }
}

export function saveLocalFlags(flags: LocalActionFlags): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(flags));
  } catch {
    /* private mode */
  }
}

function toggleIn(list: string[], id: string): string[] {
  return list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
}

export function togglePinned(flags: LocalActionFlags, id: string): LocalActionFlags {
  return { ...flags, pinned: toggleIn(flags.pinned, id) };
}

export function toggleBookmark(flags: LocalActionFlags, id: string): LocalActionFlags {
  return { ...flags, bookmarked: toggleIn(flags.bookmarked, id) };
}

export function markComplete(flags: LocalActionFlags, id: string): LocalActionFlags {
  const completed = flags.completed.includes(id)
    ? flags.completed
    : [...flags.completed, id];
  return {
    ...flags,
    completed,
    dismissed: flags.dismissed.filter((x) => x !== id),
  };
}

export function unmarkComplete(flags: LocalActionFlags, id: string): LocalActionFlags {
  return { ...flags, completed: flags.completed.filter((x) => x !== id) };
}

export function dismissAction(flags: LocalActionFlags, id: string): LocalActionFlags {
  const dismissed = flags.dismissed.includes(id)
    ? flags.dismissed
    : [...flags.dismissed, id];
  return {
    ...flags,
    dismissed,
    pinned: flags.pinned.filter((x) => x !== id),
  };
}

export function undismissAction(flags: LocalActionFlags, id: string): LocalActionFlags {
  return { ...flags, dismissed: flags.dismissed.filter((x) => x !== id) };
}
